'use client';

import {
  useEffect,
  useState
} from 'react';

interface AnimatedProgressBarProps {
  percent: number
}

// Starts at 0 and transitions to the real percent right after mount, so the
// bar visibly fills in instead of rendering already-full from SSR.
export default function AnimatedProgressBar({
  percent
}: AnimatedProgressBarProps) {

  const [ width, setWidth ] = useState(0);

  useEffect(() => {

    const raf = requestAnimationFrame(() => setWidth(percent));

    return () => cancelAnimationFrame(raf);
  }, [ percent ]);

  return (
    <div className="w-full h-3 rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden">
      <div
        className="h-full rounded-full bg-[rgba(1,158,250,0.9)] transition-all duration-1000 ease-out"
        style={{
          width: `${ width }%`
        }}
      />
    </div>
  );
}
